/* eslint-disable max-classes-per-file */
import { Injectable } from '@angular/core'
import { contract, publicContract } from '@ftr/annotations-contracts/v2'
import { Region } from '@ftr/contracts/type/court'
import { AnnotationsApiClientFactoryBase } from './annotations-api-client.factory.base'
import { AnnotationsApiClientV2, AnnotationsApiClientV2Public } from './types'

/**
 * Create a client service for ftr-annotations v2 for a given region
 */
@Injectable({
  providedIn: 'root',
})
export class AnnotationsApiClientFactoryV2 extends AnnotationsApiClientFactoryBase {
  build(region: Region): AnnotationsApiClientV2 {
    return this.buildClient(region, contract, 'annotations-v2')
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnnotationsApiClientFactoryV2Public extends AnnotationsApiClientFactoryBase {
  build(region: Region): AnnotationsApiClientV2Public {
    return this.buildClient(region, publicContract, 'annotations-v2-public')
  }
}
